import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as MDICONS from '@material-ui/icons';
import { storage } from '../../../config/firebaseConfig';

class ReportGenMessage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            reportUrl: "",
            anyReportUrlFound: true,
        }
    }

    componentDidMount = () => {
        const { project } = this.props.notificationItem;
        const { proid } = project;
        // Create a reference to the file we want to download
        var reportRef = storage.ref(`/Projects/${proid}/reports/-report.pdf`);
        // Get the download URL
        reportRef.getDownloadURL().then(url => {
            this.setState({
                anyReportUrlFound: true,
                reportUrl: url,
            })
        }).catch((error) => {
            this.setState({
                anyReportUrlFound: false,
                reportUrl: "",
            })
        });
    }

    render() {
        const { notifUtils, notificationItem, modalStyles,
            modalTitleStyle, formLabelStyle, modalWidth,
        } = this.props;

        const { reportUrl, anyReportUrlFound } = this.state;

        const { notificationIcon } = notifUtils;

        const { notify, requestCode, timestamp, isReportGen } = notificationItem;
        const momentFromNow = moment(timestamp.toDate()).fromNow();
        const notifIcon = notificationIcon[requestCode];

        const relevantButton = anyReportUrlFound ? <a target="_blank" rel="noopener noreferrer" href={reportUrl}>{isReportGen ? 'Download new report' : 'Want to download previous report?'}</a> : <React.Fragment />

        return (
            <div className="dynamicModalContainerSm">
                <div className="dynamicModalSm">
                    <h5 style={modalTitleStyle}>Report generation status:</h5>
                    <br />
                    <p><span style={{ color: "gray" }}>{notifIcon} <MDICONS.MoreVert /> </span>{notify}<span className="float-right" style={{ color: "gray", fontStyle: "italic" }}><MDICONS.Remove /> {momentFromNow}</span></p>
                    <p>{relevantButton}</p>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        userData: state.firebase.profile,
        notifUtils: state.notifUtils,
        modalStyles: state.appControl.modalStyles,
        modalWidth: state.appControl.modalWidthMedium,
        modalTitleStyle: state.appControl.modalTitleStyle,
        companyData: state.firestore.data.Company,
        alu: state.alu,
    }
}

export default connect(mapStateToProps)(ReportGenMessage);